import { Avatar, Button, keyframes, Typography } from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DOCUMENTS_REDUCER_CASE } from 'Enum/documents';
import { useDictionary } from 'Hooks';
import { RevertedArrowsBlue, RevertedArrowsWhite } from 'Images';
import { useContext, useState } from 'react';

export const OrderByDate = () => {
  const { filter, setFilter, dispatchDocuments } = useContext(DocumentsContext);
  const [isHover, setIsHover] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  const rotate = keyframes`from{ transform: rotate(0deg); } to{ transform: rotate(180deg); }`;

  const orderByHandler = () => {
    const updatedFilter = {
      ...filter,
      orderByDescending: !filter.orderByDescending,
    };
    setFilter(updatedFilter);
    dispatchDocuments({
      type: DOCUMENTS_REDUCER_CASE.FILTER,
      payload: {
        value: { filter: updatedFilter },
      },
    });
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
    }, 250);
  };

  return (
    <Button
      sx={{
        display: 'flex',
        gap: '10px',
        p: '10px 16px',
        color: '#1552E8',
        borderRadius: '10px',
        ':hover': {
          cursor: 'pointer',
          color: '#FFF !important',
          bgcolor: '#A020FF',
        },
      }}
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      onClick={orderByHandler}
    >
      <Typography variant='body1'>
        {filter.orderByDescending ? dictionary.newOld : dictionary.oldNew}
      </Typography>
      <Avatar
        alt=''
        src={isHover ? RevertedArrowsWhite : RevertedArrowsBlue}
        sx={{
          width: '24px',
          height: '24px',
          animation: isClicked ? `${rotate} .2s linear` : undefined,
        }}
      />
    </Button>
  );
};
